var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMargin04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 102,
    viewBox: "0 0 129 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot",
    clipPath: "url(#clip0_849_12455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M127.02 19.5898H20.0898V78.0398H127.02V19.5898Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.4199 33.3906V65.7906",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.5195 55.2904H43.8395C50.0895 55.2904 55.1595 50.2204 55.1595 43.9704C55.1595 37.7204 50.0895 32.6504 43.8395 32.6504H37.5195",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M64.9502 33.3906V65.7906",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M68.0498 55.2904H74.3698C80.6198 55.2904 85.6898 50.2204 85.6898 43.9704C85.6898 37.7204 80.6198 32.6504 74.3698 32.6504H68.0498",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M95.3701 65.7886H106.73C111.42 65.7886 115.22 61.9886 115.22 57.2986C115.22 52.6086 111.42 48.8086 106.73 48.8086",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M115.22 31.8203H103.86C99.1701 31.8203 95.3701 35.6203 95.3701 40.3103C95.3701 45.0003 99.1701 48.8003 103.86 48.8003",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M73.5602 96.22C76.5204 96.22 78.9202 93.8202 78.9202 90.86C78.9202 87.8998 76.5204 85.5 73.5602 85.5C70.5999 85.5 68.2002 87.8998 68.2002 90.86C68.2002 93.8202 70.5999 96.22 73.5602 96.22Z",
    stroke: "#4063AA",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M88.3004 12.1302C91.2607 12.1302 93.6604 9.7304 93.6604 6.77016C93.6604 3.80991 91.2607 1.41016 88.3004 1.41016C85.3402 1.41016 82.9404 3.80991 82.9404 6.77016C82.9404 9.7304 85.3402 12.1302 88.3004 12.1302Z",
    stroke: "#E3101B",
    strokeWidth: 2.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.0501 51.7109C15.7901 51.7109 15.7901 47.4609 13.0501 47.4609C10.3101 47.4609 10.3101 51.7109 13.0501 51.7109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.05012 87.6309C4.79012 87.6309 4.79012 83.3809 2.05012 83.3809C-0.689883 83.3809 -0.689883 87.6309 2.05012 87.6309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M29.7698 101.531C32.5098 101.531 32.5098 97.2812 29.7698 97.2812C27.0298 97.2812 27.0298 101.531 29.7698 101.531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M52.22 87.6309C54.96 87.6309 54.96 83.3809 52.22 83.3809C49.48 83.3809 49.48 87.6309 52.22 87.6309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M61.4603 13.4102C64.2003 13.4102 64.2003 9.16016 61.4603 9.16016C58.7203 9.16016 58.7203 13.4102 61.4603 13.4102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M120.53 69.9199C123.27 69.9199 123.27 65.6699 120.53 65.6699C117.79 65.6699 117.79 69.9199 120.53 69.9199Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_849_12455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.44,
    height: 101.53,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMargin04);
export default __webpack_public_path__ + "static/media/icon_margin_04.a9ed646975821c73ffba72f137dac5b6.svg";
export { ForwardRef as ReactComponent };